import { BaseContext } from '../basecontext';
import { HttpClientImpl } from '../httpclient/httpclient';
import { ResponseMapperImpl, ResponseMapper } from '../httpclient/response/responsemapper';
import { RegenerateTokenAPI } from '../../core/api/regeneratetoken/regeneratetokenapi';
import { RegenerateTokenResponse } from '../../core/api/regeneratetoken/regeneratetokenresponse';
import { RegenerateTokenRequestImpl } from '../../core/api/regeneratetoken/regeneratetokenrequest';
import { RegenerateTokenDtoImpl } from '../../core/dto/regeneratetoken/regeneratetokendto';
import { RegenerateTokenAPIProcessorImpl } from '../../core/processor/regeneneratetokenapiprocessor';
import { RoutingFeatures } from '../../ui/components/navigation/routingfeature';

export interface HandleKnownFailures
{
    handleUnAuthorised(): HandleKnownFailures;
    refreshToken(): HandleKnownFailures;
    onSuccess(success: () => void): HandleKnownFailures;
    onFailure(failure: (r: ResponseMapper) => void): HandleKnownFailures;
}

export class HandleKnownFailuresImpl implements HandleKnownFailures
{
    private isTokenRegenerating: boolean = false;
    private isUnAuthorisedHandled: boolean = false;
    private successRegenerateTasks: any[];
    private failureRegenerateTasks: any[];

    constructor(private context: BaseContext) 
    {
        this.successRegenerateTasks = [];
        this.failureRegenerateTasks = [];
    }

    onSuccess(success: () => void): HandleKnownFailures 
    {
        this.successRegenerateTasks.push(success);

        return this;
    }

    onFailure(failure: (r: ResponseMapper) => void): HandleKnownFailures 
    {
        this.failureRegenerateTasks.push(failure);

        return this;
    }

    refreshToken(): HandleKnownFailures 
    {
        if (!this.isTokenRegenerating)
        {
            this.isTokenRegenerating = true;
        
             let refreshTokenDto = new RegenerateTokenDtoImpl();
             refreshTokenDto.setRefreshToken(this.context.getUserContext().getRefreshToken());
    
            new RegenerateTokenAPIProcessorImpl(this.context, new RegenerateTokenAPI(new HttpClientImpl(), this.context))
                .success((response: RegenerateTokenResponse)=>
                {
                    this.context.getUserContext().setAccessToken(response.getRegenerateTokenDto().getAccessToken());
                    this.context.getUserContext().setRefreshToken(response.getRegenerateTokenDto().getRefreshToken());
                    this.context.getUserContext().setExpiry((response.getRegenerateTokenDto().getExpiry() 
                            - this.context.getProperty().getRefreshTokenDelta()) + Date.now());
                    this.context.setUserContext(this.context.getUserContext());

                    this.successRegenerateTasks.forEach((successhandler: any)=>
                            {
                                successhandler();
                            });
                            
                    this.isTokenRegenerating = false;

                    this.successRegenerateTasks.length = 0;
                    this.failureRegenerateTasks.length = 0;

                    })
                .failure((response: RegenerateTokenResponse)=>
                    {
                        let responseMapper = new ResponseMapperImpl();
                         responseMapper.setStatusMsg(response.getDescription());
                            responseMapper.setStatusCode(String(response.getAPIFeature()));

                            //check for 498 if true dont delete call refresh token again
                            //else loop nd give call back
                            // this.failureRegenerateTasks.forEach((failurehandler: any)=>
                            // {
                            //     failurehandler(responseMapper);
                            // });

                            this.successRegenerateTasks.length = 0;
                            this.failureRegenerateTasks.length = 0;

                            this.isTokenRegenerating = false;
                            this.context.logout();
                            this.context.getRedirectionHandler().routeNextFeature(RoutingFeatures.LOGIN, false);
                    })
                    .execute(new RegenerateTokenRequestImpl(refreshTokenDto));
                }
        
      return this;
    }

    handleUnAuthorised(): HandleKnownFailures 
    {
        if(!this.isUnAuthorisedHandled)
        {
            this.isUnAuthorisedHandled = true;

            this.context.logout();
            this.context.getRedirectionHandler().routeNextFeature(this.context.getRoutingPath() +
            "/" + RoutingFeatures.LOGIN, true);
        }

        return this;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/handleknownfailures/handleknownfailures.ts